import { render, staticRenderFns } from "./index.vue?vue&type=template&id=703b667a&scoped=true&"
import script from "./index.vue?vue&type=script&crossorigin=anonymous&lang=js&"
export * from "./index.vue?vue&type=script&crossorigin=anonymous&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=703b667a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b667a",
  null
  
)

export default component.exports